export const getSearchObj = data => {
  switch (data?.type) {
    case "state":
    case "depot":
      return { [data?.type]: data?.value?.trim(), group: "Card" };
    default:
      return { [data?.type]: data?.value?.trim() };
  }
};
